'use strict';

import {Flow} from "../lib/flowjs";
import moment from 'moment';
import ngTimePicker from 'angular-material-time-picker';

//moment().format('YYYY-MM-DD');
moment().format('DD/MM/YYYY');

const EwSiteApp = angular.module('EwSiteApp', ['ngMaterial', 'ngMessages', 'ngSanitize', 'ngLocale', 'md.data.table', 'flow', ngTimePicker]);

EwSiteApp.config(["$mdThemingProvider", function($mdThemingProvider) {
//	$mdThemingProvider.theme('default').primaryPalette('teal').accentPalette('deep-orange');//.warnPalette('red').backgroundPalette('grey');
//	$mdThemingProvider.theme('default').primaryPalette('teal').accentPalette('orange');//.warnPalette('red').backgroundPalette('grey');
	/*$mdThemingProvider.theme('default').primaryPalette('teal', {
		'default': '700'
	}).accentPalette('orange', {
		'default': '900'
	});//.warnPalette('red').backgroundPalette('grey');*/
	$mdThemingProvider.definePalette('esfablue', {
		'50': 'afe2ff',
		'100': '63c7ff',
		'200': '2bb3ff',
		'300': '0091e2',
		'400': '007ec4',
		'500': '006aa5',
		'600': '005686',
		'700': '004368',
		'800': '002f49',
		'900': '001b2b',
		'A100': 'a5dfff',
		'A200': '3fbaff',
		'A400': '008bd8',
		'A700': '007abe',
		'contrastDefaultColor': 'light',
		'contrastDarkColors': [
		  '50',
		  '100',
		  '200',
		  'A100',
		  'A200'
		],
		'contrastLightColors': [
		  '300',
		  '400',
		  '500',
		  '600',
		  '700',
		  '800',
		  '900',
		  'A400',
		  'A700'
		]
	  });
	  $mdThemingProvider.definePalette('esfabrown', {
		'50': 'ffffff',
		'100': 'ebe3dc',
		'200': 'd6c6b9',
		'300': 'bca18c',
		'400': 'b09278',
		'500': 'a58265',
		'600': '957357',
		'700': '81644c',
		'800': '6e5540',
		'900': '5b4635',
		'A100': 'ffffff',
		'A200': 'A58265',
		'A400': 'c69b77',
		'A700': '8B6B50',
		'contrastDefaultColor': 'light',
		'contrastDarkColors': [

		],
		'contrastLightColors': [
		  '50',
		  '100',
		  '200',
		  '300',
		  '400',
		  '500',
		  'A100',
		  'A200',
		  'A400',
		  'A700'
		]
	  });
	$mdThemingProvider.theme('default').primaryPalette('esfablue').accentPalette('esfabrown');
	$mdThemingProvider.theme("success-toast");
	$mdThemingProvider.theme("error-toast");
}]);

EwSiteApp.config(["$httpProvider", function($httpProvider) {
	if(typeof(jsData) !== 'undefined' && typeof(jsData.cfgXsrf) !== 'undefined' && typeof(jsData.cfgXsrf.cookieName) !== 'undefined'){
		$httpProvider.defaults.xsrfCookieName = jsData.cfgXsrf.cookieName;
		$httpProvider.defaults.xsrfHeaderName = 'X-' + jsData.cfgXsrf.cookieName;
	}
}]);

EwSiteApp.config(["$mdDateLocaleProvider", function($mdDateLocaleProvider) {
	$mdDateLocaleProvider.firstDayOfWeek = 1;

	if(typeof(jsData) !== 'undefined' && typeof(jsData.cfgTime) !== 'undefined'){
		moment.locale('en-gb');

		$mdDateLocaleProvider.formatDate = function(date) {
			var m = moment(date);
			const format = 'DD/MM/YYYY';
			return m.isValid() ? m.format(format) : '';
		};

		$mdDateLocaleProvider.parseDate = function (dateString) {
			var m = moment(dateString, 'DD/MM/YYYY', true);
			return m.isValid() ? m.toDate() : new Date(NaN);
		};
	}
}]);

EwSiteApp.filter('u2date', ["$filter", "$locale", function($filter, $locale){
	return function (udate){
		if(isNaN(udate) || parseInt(udate) === 0){
			return '';
		}
//		var format = 'yyyy-MM-dd';
		let format = $locale.DATETIME_FORMATS.shortDate;
		if(arguments[1]){
			format = arguments[1];
		}
		return $filter('date')(udate*1000, format);
	};
}]);

EwSiteApp.filter('suffix', ["$filter", function($filter){
	return function (value, suffix){
		if(value !== ''){
			return value + suffix;
		}
		return '';
	};
}]);

EwSiteApp.config(['flowFactoryProvider', function (flowFactoryProvider) {
	function getJsCookieValue(a){
		let b = document.cookie.match('(^|;)\\s*' + a + '\\s*=\\s*([^;]+)');
		return b ? b.pop() : '';
	}
	flowFactoryProvider.defaults = {
		target: '',
		permanentErrors: [202, 404, 500, 501],
//		permanentErrors: [414, 500, 501],
		maxChunkRetries: 1,
		chunkRetryInterval: 5000,
		simultaneousUploads: 1,
		singleFile: true,
		chunkSize: 2 * 1024 * 1024,
		forceChunkSize: true,
		testChunks: false
	};
	// Apejimas https://lightrun.com/answers/flowjs-ng-flow-unable-to-initialize-module-using-browserify
	//	https://github.com/flowjs/ng-flow/issues/92
	flowFactoryProvider.factory = function (opts) {
		let Flow = require('@flowjs/flow.js/dist/flow.js');
		return new Flow(opts);
	};
	// Add XSRF header to upload requests
	if(typeof(jsData) !== 'undefined' && typeof(jsData.cfgXsrf) !== 'undefined' && typeof(jsData.cfgXsrf.cookieName) !== 'undefined'){
		let xsrf_token = getJsCookieValue(jsData.cfgXsrf.cookieName);
		if(xsrf_token !== ''){
			flowFactoryProvider.defaults.headers = {};
			flowFactoryProvider.defaults.headers['X-' + jsData.cfgXsrf.cookieName] = xsrf_token;
		}
	}
	flowFactoryProvider.on('fileSuccess', function (file, response) {
		file.response = angular.fromJson(response);
	});
}]);

EwSiteApp.filter('nl2br', function(){
	return function (text){
		if(text){
			if(typeof(text.replace) === 'function'){
				return text.replace(/\n/g, "<br\>");
			}
			else{
				return text;
			}
		}
		return '';
	};
});

EwSiteApp.filter('tr', ["jsDataService", function(jsDataService){
	const trData = jsDataService.get('translations', {});
	return function (text){
		if(typeof(trData[text]) !== 'undefined'){
			return trData[text];
		}
		if(arguments[1] && arguments[1] !== ''){
			return arguments[1];
		}
		return '*' + text + '*';
	};
}]);

EwSiteApp.run(['$rootScope', '$http', 'notify', 'pageProgress', function($rootScope, $http, notify, pageProgress){
	$rootScope.pageInProgress = function(){
		return pageProgress.getState();
	};
	$rootScope.onlyHttpProcess = function(httpProvider){
		httpProvider.then((response) => {
			if(response.data){
				if(response.data.success){
					if(typeof(response.data.url) !== 'undefined'){
						$rootScope.goUrl(response.data.url);
//						window.location.href = response.data.url;
					}
				}
				if(response.data.message){
					if(typeof(response.data.reloadpage) !== 'undefined' && response.data.reloadpage){
						pageProgress.start();
					}
					notify(response.data.message, !response.data.success, (typeof(response.data.reloadpage) !== 'undefined' && response.data.reloadpage));
				}
				else if(typeof(response.data.reloadpage) !== 'undefined' && response.data.reloadpage){
					pageProgress.start();
					window.location.reload(true);
				}
			}
			else{
				console.log(response);
				notify('Communication Error', true);
			}
		}, (response) => {
			console.log("HTTP ERROR");
			console.log(response);
			notify('Network error, Status: ' + response.status, true);
		});
		return httpProvider;
	};
	$rootScope.basicHttpProcess = function(httpProvider){
		pageProgress.setHttp(httpProvider);
		return $rootScope.onlyHttpProcess(httpProvider);
	};
	$rootScope.basicHttpConfigProcess = function(httpConfig){
		return $rootScope.basicHttpProcess($http(httpConfig));
	};
	$rootScope.goUrl = function(urlString){
		pageProgress.start();
		window.location.href = urlString;
	};
}]);

export {EwSiteApp};
